import { useEffect, useState } from 'react';
import { number } from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  font-size: 1rem;
`;

function RecordsInfo({ pageIndex, pageSize, totalRows}) {
  const [endIdx, setEndIdx] = useState(0);

  useEffect(() => {
    const endNumber = (pageIndex+1)*pageSize;
    setEndIdx(endNumber > totalRows ? totalRows : endNumber);
  }, [pageIndex, pageSize, totalRows]);

  if(totalRows === 0) {
    return null;
  }

  return (
    <Wrapper>
      Showing {pageIndex*pageSize+1} to {endIdx} of {totalRows} entries
    </Wrapper>
  );
}

RecordsInfo.propTypes = {
  pageIndex: number.isRequired,
  pageSize: number.isRequired,
  totalRows: number.isRequired,
}

export default RecordsInfo;